import * as React from "react"

const SvgLayoutMasonry = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15 7.571h4v-2h-4zm-10 4h4v-6H5zm10 8h4v-6h-4zm-10 0h4v-2H5zm8.287-10.287q.288.287.713.287h6q.424 0 .712-.287A.97.97 0 0 0 21 8.57v-4a.97.97 0 0 0-.288-.712A.97.97 0 0 0 20 3.57h-6a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v4a.97.97 0 0 0 .287.713Zm-10 4q.288.287.713.287h6a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.714v-8a.97.97 0 0 0-.287-.712A.97.97 0 0 0 10 3.57H4a.97.97 0 0 0-.712.288A.97.97 0 0 0 3 4.57v8q0 .426.288.713Zm10 8q.288.288.713.287h6q.424 0 .712-.287A.97.97 0 0 0 21 20.57v-8a.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288h-6a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v8a.97.97 0 0 0 .287.713Zm-10 0q.288.288.713.287h6a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.714v-4a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288H4a.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v4q0 .425.288.713Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgLayoutMasonry
